const clientReferences = new WeakMap();

function firstText(...values) {
	return values.find(value => typeof value === 'string' && value.trim()) || null;
}

function headerValue(headers, name) {
	if(!headers) return null;
	if(typeof headers.get === 'function') return headers.get(name) || headers.get(name.toLowerCase());
	let entry = Object.keys(headers).find(key => key.toLowerCase() === name.toLowerCase());
	return entry ? headers[entry] : null;
}

function localReference(error) {
	if(error && typeof error === 'object') {
		if(!clientReferences.has(error)) clientReferences.set(error, `browser-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`);
		return clientReferences.get(error);
	}
	return `browser-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

// OAuth APIs use a small JSON error object, while older Blackout endpoints use
// a JSON:API envelope. Normalise both here so no hosted OAuth page can discard
// the one diagnostic reference that lets support find the failed request.
export function describeOAuthError(error, fallback) {
	let response = error && error.response;
	let data = response && response.data ? response.data : {};
	let envelope = data && data.errors && !Array.isArray(data.errors) ? data.errors : {};
	let reference = firstText(
		data && data.error_reference,
		data && data.errorReference,
		envelope && envelope.error_reference,
		envelope && envelope.errorReference,
		headerValue(response && response.headers, 'X-Error-Reference'),
		headerValue(response && response.headers, 'X-Correlation-ID'),
	);
	let status = Number.isInteger(response && response.status) ? response.status : null;
	let message = firstText(data && data.error_description, envelope && envelope.message, data && data.message);
	if(!message) {
		message = response
			? fallback
			: 'Blackout did not return a response. Check your connection and try again.';
	}
	return {
		message,
		status,
		reference: reference || localReference(error),
		hasServerReference: Boolean(reference),
	};
}
